import { PublicClientApplication, type Configuration } from '@azure/msal-browser'

const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID as string,
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID as string}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
}

export const msalInstance = new PublicClientApplication(msalConfig)

export const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
}

export const apiRequest = {
    scopes: [`api://${import.meta.env.VITE_AZURE_CLIENT_ID as string}/access_as_user`],
}
